import React from 'react';
import { motion } from 'framer-motion';
export function WhySection() {
  return <section className="py-24 px-6 bg-[#0f172a] text-white overflow-hidden relative" data-id="element-182">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-20" data-id="element-183">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-teal-500 rounded-full blur-[120px]" data-id="element-184" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[400px] h-[400px] bg-indigo-500 rounded-full blur-[100px]" data-id="element-185" />
      </div>

      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 items-center relative z-10" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-187">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 leading-tight" data-id="element-188">
            Why high-functioning women get stuck here
          </h2>
          <div className="space-y-6 text-slate-300 text-lg leading-relaxed" data-id="element-189">
            <p data-id="element-190">
              Because you’re the reliable one. You don’t collapse. You
              compensate. You respond. You handle it. You show up.
            </p>
            <p data-id="element-191">And the world quietly rewards you for it… with more.</p>
            <p data-id="element-192">
              So you try to fix it with discipline: more productivity hacks,
              stricter routines, another planner. It helps… until life hits.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="bg-white/10 backdrop-blur-md p-8 md:p-10 rounded-2xl border border-white/10" data-id="element-193">
          <h3 className="text-xl font-semibold text-teal-300 mb-4 uppercase tracking-wider text-sm" data-id="element-194">
            The Core Insight
          </h3>
          <p className="text-2xl md:text-3xl font-medium leading-snug mb-6" data-id="element-195">
            You can’t build calm on top of an activated nervous system.
          </p>
          <p className="text-lg text-slate-300" data-id="element-196">
            Most advice fails because it assumes you can access calm whenever
            you want. But calm isn't a mindset—it's a biological state. You have
            to reset the system first.
          </p>
        </motion.div>
      </div>
    </section>;
}